import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import { fetchLocationsForBuildingAction } from '../../redux/actions/buildings';

const mapDispatchToProps = (dispatch, { buildingId }) => ({
  fetchFunction: () => {
    if (buildingId) dispatch(fetchLocationsForBuildingAction(buildingId)).catch(() => {});
  },
});

export default connect(null, mapDispatchToProps)(GenericLoader);
